import { render } from "./LinksCard.vue?vue&type=template&id=36f8b058&scoped=true&ts=true"
import script from "./LinksCard.vue?vue&type=script&lang=ts"
export * from "./LinksCard.vue?vue&type=script&lang=ts"

import "./LinksCard.vue?vue&type=style&index=0&id=36f8b058&scoped=true&lang=css"

import exportComponent from "/dados/apps/pdcrm/app_atual/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f8b058"]])

export default __exports__